var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup83(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 75,
    viewBox: "0 0 33 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 72.0748H30.5L25.6163 56.4262L16.9859 33.497L2.5 72.0748Z",
    fill: "#D6AF66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9859 33.497V19.4688M16.9859 33.497L2.5 72.0748H30.5L25.6163 56.4262L16.9859 33.497ZM6.36324 38.9768L9.33721 33.497L16.9859 19.4688L23.2879 30.9233L27.5698 38.9768",
    stroke: "#D6AF66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8333 7.16639C11.8333 8.40407 12.3249 9.59105 13.2001 10.4662C14.0753 11.3414 15.2622 11.8331 16.4999 11.8331C17.7376 11.8331 18.9246 11.3414 19.7998 10.4662C20.6749 9.59105 21.1666 8.40407 21.1666 7.16639C21.1666 5.92872 20.6749 4.74173 19.7998 3.86656C18.9246 2.99139 17.7376 2.49973 16.4999 2.49973C15.2622 2.49973 14.0753 2.99139 13.2001 3.86656C12.3249 4.74173 11.8333 5.92872 11.8333 7.16639Z",
    fill: "#D6AF66",
    stroke: "#D6AF66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup83);
export default __webpack_public_path__ + "static/media/Group 83.822abeb3a41ec63e3ca10520b353a880.svg";
export { ForwardRef as ReactComponent };